import { API_SEASONS, API_URL } from "../ApiPaths";

/** TEAM */
export const getSeasons = async () => {
  const res = await fetch(API_URL + API_SEASONS, {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  });
  if (!res.ok) {
    throw new Error("Network response was not ok");
  }
  return res.json();
};

export const addNewSeason = async (tmpNew: string) => {
  const res = await fetch(API_URL + API_SEASONS, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ name: tmpNew }),
  });

  if (!res.ok) {
    throw new Error("Network response was not ok");
  }

  return res.json();
};

export const deleteSeason = async (id: string) => {
  const res = await fetch(`${API_URL}${API_SEASONS}/${id}`, {
    method: "DELETE",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (!res.ok) {
    throw new Error("Network response was not ok");
  }

  return res.json();
};
